module.exports = __webpack_public_path__ + "img/LiveWellnessIcon.ab0daa43.png";